import { Box, Checkbox, FormControlLabel, FormGroup, Grid, Stack, TextField } from "@mui/material";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { useEffect, useState } from "react";
import { currencyMask, formatIntegerToCurrency, getNumberFromCurrencyMask } from "../../../shared/lib/numbers";
import CarAutocomplete from "../../car/ui/car-autocomplete-search-bar.component";
import CostumerAutocompleteSearchBar from "../../costumer/ui/costumer-autocomplete-search-bar.component";
import { Car, isValidCar } from "../../car/model/car";
import { Costumer } from "../../costumer/model/costumer";
import { PaperCard } from "../../../shared/ui/paper-card/paper-card.component";

interface PericiaHeaderProps {
  props: Props;
}

interface Props {
  car: Car;
  costumer: Costumer;
  pricePerHour: number;
  shouldUnmount: boolean;
  unmountPrice: number;
  date: Date;
  createdBy?: string;
  disableCostumer?: boolean;
  updateDate: (date: Date) => void;
  updateCostumer: (costumer: Costumer) => void;
  updateCar: (car: Car) => void;
  updatePricePerHour: (pricePerHour: number) => void;
  updateShouldUnmount: (shouldUnmount: boolean) => void;
  updateUnmountPrice: (unmountPrice: number) => void;
}

const PericiaHeader: React.FC<PericiaHeaderProps> = ({ props }) => {
  const {
    costumer,
    car,
    pricePerHour,
    unmountPrice,
    shouldUnmount,
    date,
    updateCostumer,
    updateCar,
    updatePricePerHour,
    updateShouldUnmount,
    updateUnmountPrice,
    updateDate,
    createdBy,
    disableCostumer = false
  } = props;
  const [unmountPriceMask, setUnmountPriceMask] = useState("");

  const handleShouldUnmountChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    return updateShouldUnmount(!shouldUnmount);
  };

  const handleUnmountPriceChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target;
    return setUnmountPriceMask(currencyMask(value));
  };

  const handleUnmountPriceChangeOnBlur = () => {
    return updateUnmountPrice(getNumberFromCurrencyMask(unmountPriceMask));
  };

  const handlePricePerHourChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target;
    return updatePricePerHour(Number(value));
  };

  useEffect(() => {
    setUnmountPriceMask(currencyMask(formatIntegerToCurrency(unmountPrice)));
  }, [unmountPrice]);

  return (
    <Box component="form" noValidate sx={{ mt: 3, mb: 5 }}>
      <PaperCard title=" Informações da perícia">
        <Grid container spacing={2} mt={1}>
          <Grid item xs={12} sm={12}>
            <CarAutocomplete car={car} onCarSelected={updateCar} costumerId={costumer.id} />
          </Grid>
          <Grid item xs={12} sm={12}>
            <CostumerAutocompleteSearchBar
              value={costumer}
              onChange={(c) => updateCostumer(c || {} as Costumer)}
              disabled={disableCostumer}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              type={"number"}
              required
              fullWidth
              name="pricePerHour"
              label="CHF/Ora"
              id="pricePerHour"
              variant="standard"
              value={pricePerHour.toString()}
              onChange={handlePricePerHourChange}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <Stack spacing={3}>
                <DatePicker
                  label="Data"
                  openTo="month"
                  inputFormat="DD/MM/YYYY"
                  views={["year", "month", "day"]}
                  value={date}
                  onChange={(newValue) => {
                    if (newValue) updateDate(new Date(newValue));
                  }}
                  renderInput={(params) => <TextField {...params} variant="standard" />}
                />
              </Stack>
            </LocalizationProvider>
          </Grid>
          <Grid item xs={6} sm={6}>
            <FormGroup>
              <FormControlLabel
                control={<Checkbox onChange={handleShouldUnmountChange} value={shouldUnmount} checked={shouldUnmount} />}
                label="Desmontar"
              />
            </FormGroup>
          </Grid>
          <Grid item xs={6} sm={6} display={shouldUnmount ? "block" : "none"}>
            <TextField
              required
              fullWidth
              name="unmount"
              label="Preço desmontagem"
              id="unmount"
              variant="standard"
              value={unmountPriceMask}
              onChange={handleUnmountPriceChange}
              onBlur={handleUnmountPriceChangeOnBlur}
            />
          </Grid>
          {createdBy && (
            <Grid item xs={12} sm={12}>
              <TextField name="createdBy" label="Perito" id="createdBy" variant="outlined" value={createdBy} disabled />
            </Grid>
          )}
        </Grid>
      </PaperCard>
    </Box>
  );
};

export default PericiaHeader;
